export class LoadCityGatesAction {
  static readonly type = '[CityGates] Load City Gates';
  constructor(public filters?: string) {}
}

export class ClearCityGatesAction {
  static readonly type = '[CityGates] Clear City Gates';
}

